import { IconVariant } from '../Icon';
import { RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

const defaultVariant: IconVariant = 'tooltip-icon';

export type Direction = 'top' | 'bottom' | 'left' | 'right' | 'custom';

/** Properties interface of the Tooltip component. */
export interface TooltipProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  field: RichTextField;
  className?: string;
  icon?: IconVariant;
  delay?: number;
  direction?: Direction;
}

/** Default properties of the Tooltip component. */
export const defaultProps: Partial<TooltipProps> = {
  icon: defaultVariant,
  delay: 200,
  direction: 'top',
};
